import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import ProductsPage from './products/Products.js';
import ProductDetailPage from './products/ProductDetailPage.js';
import RequestQuotePage from './products/RequestQuotePage.js';
import SalesPage from './pages/Sales.js';
import Sectors from './pages/Sectors.js';
import Contact from './pages/ContactPage.js';

import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            
            <Route path="/products" element={<ProductsPage />} /> 
            <Route path="/products/:productId" element={<ProductDetailPage />} />
            <Route path="/products/request" element={<RequestQuotePage />} />
            <Route path="/sales" element={<SalesPage />} />
            <Route path="/sectors" element={<Sectors />} /> 
            <Route path="/contact" element={<Contact />} /> 
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;